import React from 'react'
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
export default function Experiences() {
    const cardStyle = {
        background: 'linear-gradient(180deg, rgba(23, 18, 40, 0.95), rgba(14, 10, 26, 0.92))',
        color: '#fff',
        border: '1px solid rgba(210, 180, 255, 0.12)',
        boxShadow: '0 24px 55px rgba(10, 7, 23, 0.35)'
    };

    return (
        <div>
            <VerticalTimeline>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    contentStyle={cardStyle}
                    contentArrowStyle={{ borderRight: '7px solid rgb(142, 77, 255)' }}
                    date="Dec 2024 - Sept 2025"
                    iconStyle={{ background: 'rgb(142, 77, 255)', color: '#fff' }}

                >
                    <h3 className="vertical-timeline-element-title">Gen AI Full-Stack Software Engineer</h3>
                    <h4 className="vertical-timeline-element-subtitle purple">Commonwealth Bank of Australia</h4>
                    <p>
                        Generative AI, Insurance, Finance,  &nbsp;
                        <br />
                        Exposure: Microservices, Event-Driven Architecture, Confulent Kafka.

                    </p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    contentStyle={cardStyle}
                    contentArrowStyle={{ borderRight: '7px solid rgb(142, 77, 255)' }}
                    date="March 2021 - Nov 2024"
                    iconStyle={{ background: 'rgb(142, 77, 255)', color: '#fff' }}

                >
                    <h3 className="vertical-timeline-element-title">Software Development Engineer 2</h3>
                    <h4 className="vertical-timeline-element-subtitle purple">DataCore Softwares</h4>
                    <p>
                        Research and Development &nbsp;
                        <br />
                        Exposure: Powershell, C#,  DotNet, Nunit, Git,
                        WPF, WCF, Dialogflow, Grafana, Nodejs, Postman, Nunit.

                    </p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    contentStyle={cardStyle}
                    contentArrowStyle={{ borderRight: '7px solid rgb(142, 77, 255)' }}
                    date="June 2024 - present | Part Time"
                    iconStyle={{ background: 'rgb(142, 77, 255)', color: '#fff' }}

                >
                    <h3 className="vertical-timeline-element-title">Brain Research Consultant</h3>
                    <h4 className="vertical-timeline-element-subtitle purple">WorldQuant</h4>
                    <p>
                        Research and Development, Alpha Generation, Quantative Finance &nbsp;
                        <br />
                        Exposure: Quant, Alpha Generation, Quant Finance.

                    </p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    date="August 2020 - March 2021"
                    contentStyle={cardStyle}
                    contentArrowStyle={{ borderRight: '7px solid rgb(108, 51, 184)' }}
                    iconStyle={{ background: 'rgb(108, 51, 184)', color: '#fff' }}
                >
                    <h3 className="vertical-timeline-element-title">Program Analyst Trainee</h3>
                    <h4 className="vertical-timeline-element-subtitle purple">Cognizant Technology Solutions</h4>
                    <p>
                        Cloud technology, Analyst and Automation
                        &nbsp;
                        <br />
                        Exposure: Docker, Java, Shell Scripting, Azure.
                    </p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    date="March 2019 - May 2019"
                    contentStyle={cardStyle}
                    contentArrowStyle={{ borderRight: '7px solid rgb(108, 51, 184)' }}
                    iconStyle={{ background: 'rgb(108, 51, 184)', color: '#fff' }}
                >
                    <h3 className="vertical-timeline-element-title">GSSOC'19</h3>
                    <h4 className="vertical-timeline-element-subtitle purple">GirlScript  Summer of Code </h4>
                    <p>
                        Open Source Contributor
                        &nbsp;
                        <br />
                        Exposure: Python, GoogleDrive API
                    </p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    date="June 2018 - Dec 2018"
                    contentStyle={cardStyle}
                    contentArrowStyle={{ borderRight: '7px solid rgb(108, 51, 184)' }}

                    iconStyle={{ background: 'rgb(108, 51, 184)', color: '#fff' }}
                >
                    <h3 className="vertical-timeline-element-title">Summer Intern</h3>
                    <h4 className="vertical-timeline-element-subtitle purple">FNplus Tech</h4>
                    <p>
                        Developer Advocate
                        &nbsp;
                        <br />
                        Exposure: JavaScript, Googlecloud, Nodejs.
                    </p>
                </VerticalTimelineElement>
            </VerticalTimeline>
        </div>
    )
}
